<template>
    <div class="flex-col justify-start items-center gap-6 w-full flex">
        <h3
            class="text-black text-opacity-50 text-base font-medium leading-normal text-center"
        >
            Featuring award booking availability from top hotel brands
        </h3>
        <!-- START HOTEL BRANDS -->
        <div class="w-5/6 justify-center sm:flex hidden gap-8">
            <div
                v-for="(group, i) in allGroups"
                class="relative flex-col justify-start items-start flex"
                :key="`group-${i}`"
            >
                <img
                    :alt="group.shortName"
                    :src="`/images/${group.image}`"
                    class="w-auto h-10 relative flex-col justify-start items-start mx-6"
                />
            </div>
        </div>
        <Carousel
            :items-to-show="2"
            :wrap-around="true"
            class="w-5/6 sm:hidden"
            :autoplay="1000"
            snap-align="start"
        >
            <Slide v-for="(group, i) in allGroups" :key="`group-${i}`">
                <img
                    :alt="group.shortName"
                    :src="`/images/${group.image}`"
                    class="w-auto h-8 relative flex-col justify-start items-start mx-6"
                />
            </Slide>
        </Carousel>
    </div>
</template>
<script setup>
import { Carousel, Slide, Navigation } from 'vue3-carousel';
import { useHotelsStore } from '@/store/hotels';
import { storeToRefs } from 'pinia';

const store = useHotelsStore();

const { allGroups } = storeToRefs(store);
</script>
